module.exports = __webpack_public_path__ + "img/g-logo.b7727941.svg";